import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import lang from '@blade/common/pages/alert-details/lang/index';
import { HandlealAlarmType } from '@blade/common/store/alrm-type';
import deviceSelect from '@blade/common/components/device-cascader-select/index.vue';
import { AlarmCenterModule } from '@blade-sxp/alarm-center/store/index';
import datePicker from '@blade/common/components/date-time-select/index.vue';
let default_1 = class default_1 extends Vue {
    userLastOperationRecord;
    dialogVisible = true;
    defaultTime = ['00:00:00', '23:59:59'];
    formData = {
        incidentStatus: null,
        dates: [],
        deviceIds: [],
        incidentTypes: [],
        alertLevel: null,
        favorite: null,
    };
    favoriteOptions = [
        { value: '', label: `${this.$t('all')}` },
        { value: true, label: `${this.$t('starred')}` },
        { value: false, label: `${this.$t('notStarred')}` },
    ];
    statusOptions = [
        { value: '', label: `${this.$t('all')}` },
        { value: 'CONTINUE', label: `${this.$t('continue')}` },
        { value: 'SOLVED', label: `${this.$t('solved')}` },
        { value: 'IGNORED', label: `${this.$t('ignored')}` },
    ];
    levelOptions = [
        { value: '', label: `${this.$t('all')}` },
        { value: 'CRITICAL', label: `${this.$t('critical')}` },
        { value: 'MAJOR', label: `${this.$t('major')}` },
        { value: 'MINOR', label: `${this.$t('minor')}` },
    ];
    get alarmTypeTree() {
        const typeOption = [
            {
                value: 'null',
                label: `${this.$t('all')}`,
                children: null,
            },
            ...HandlealAlarmType.alarmTypeTree,
        ];
        return typeOption;
    }
    onUpdateUserLastOperationRecord() {
        this.formData = { ...this.userLastOperationRecord };
        this.formData.dates = [];
        if (this.formData?.dateStart) {
            this.formData.dates?.push(this.formData.dateStart);
        }
        if (this.formData?.dateEnd) {
            this.formData.dates?.push(this.formData.dateEnd);
        }
        if (this.userLastOperationRecord?.incidentTypes && this.userLastOperationRecord?.incidentTypes[0]) {
            this.formData.incidentTypes = this.changeDetSelect(this.userLastOperationRecord?.incidentTypes[0], this.alarmTypeTree);
        }
    }
    onChangeFormData() {
        const newObj = {
            deviceIds: this.formData.deviceIds,
            favorite: this.formData.favorite === '' ? null : this.formData.favorite,
            incidentStatus: this.formData.incidentStatus === '' ? null : this.formData.incidentStatus,
            alertLevel: this.formData.alertLevel === '' ? null : this.formData.alertLevel,
            incidentTypes: this.getTypeValue(this.formData.incidentTypes || []),
            dateStart: this.formData.dates ? this.formData.dates[0] : '',
            dateEnd: this.formData.dates ? this.formData.dates[1] : '',
            dates: this.formData.dates,
        };
        AlarmCenterModule.updateSearchdata(newObj);
    }
    changeDetSelect(key, treeData) {
        let arr = [];
        let returnArr = [];
        let depth = 0;
        function childrenEach(childrenData, depthN) {
            for (let j = 0; j < childrenData.length; j++) {
                depth = depthN;
                arr[depthN] = childrenData[j].value;
                if (childrenData[j].value === key) {
                    returnArr = arr.slice(0, depthN + 1);
                    break;
                }
                else {
                    const newData = childrenData[j]?.children || [];
                    if (newData.length > 0) {
                        depth++;
                        childrenEach(newData, depth);
                    }
                }
            }
            return returnArr;
        }
        return childrenEach(treeData, depth);
    }
    getTypeValue(val) {
        let newArr = val.slice(-1);
        if (newArr[0] === 'null') {
            newArr = [];
        }
        return newArr;
    }
    handleReset() {
        this.formData = {
            incidentStatus: null,
            dates: [],
            deviceIds: [],
            incidentTypes: [],
            alertLevel: null,
            favorite: null,
        };
    }
    handleClose() {
        this.$emit('close-box');
    }
    handleCancel() {
        this.$emit('close-box');
    }
    handleConfirm() {
        this.$emit('close-box');
        this.$emit('update-searchBox');
    }
};
__decorate([
    Prop()
], default_1.prototype, "userLastOperationRecord", void 0);
__decorate([
    Watch('userLastOperationRecord')
], default_1.prototype, "onUpdateUserLastOperationRecord", null);
__decorate([
    Watch('formData', { deep: true })
], default_1.prototype, "onChangeFormData", null);
default_1 = __decorate([
    Component({
        name: 'searchBox',
        components: { deviceSelect, datePicker },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
